/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Spending_Cap_Amount_LabelInputs */



/**
* | output |
* | --- |
* | "Monthly spending cap (€)" |
*
* @param {Gateway_Spending_Cap_Amount_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_spending_cap_amount_label = /** @type {((inputs?: Gateway_Spending_Cap_Amount_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Spending_Cap_Amount_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Monatliches Ausgabenlimit (€)")
	return /** @type {LocalizedString} */ ("Monthly spending cap (€)")
});